import { useEffect, useState, useCallback } from 'react';
import { useSocket } from '../context/SocketContext';

/**
 * Hook que escucha actualizaciones en tiempo real de una orden específica.
 * Cuando el trabajador cambia estado desde la APP, la PWA recibe la notificación.
 *
 * @param {number} idOrden - ID de la orden a observar
 * @param {function} onUpdate - Callback cuando la orden se actualiza
 * @returns {{ ordenModificada: boolean, ultimaActualizacion: object, resetear: function }}
 */
export const useOrdenRealtime = (idOrden, onUpdate) => {
  const { socket } = useSocket();
  const [ordenModificada, setOrdenModificada] = useState(false);
  const [ultimaActualizacion, setUltimaActualizacion] = useState(null);

  const resetear = useCallback(() => {
    setOrdenModificada(false);
    setUltimaActualizacion(null);
  }, []);

  useEffect(() => {
    if (!socket || !idOrden) return;

    const handleOrdenActualizada = (data) => {
      // Verificar que es la orden que estamos viendo
      const ordenId = data?.id_orden_servicio || data?.id;
      if (parseInt(ordenId) === parseInt(idOrden)) {
        console.log('🔔 PWA: Orden actualizada en tiempo real:', data);
        setOrdenModificada(true);
        setUltimaActualizacion({
          estado: data.id_estado_servicio,
          nombre_estado: data.nombre_estado || data.descripcion_estado,
          fecha: new Date().toISOString(),
        });
        if (onUpdate) onUpdate(data);
      }
    };

    socket.on('ordenActualizada', handleOrdenActualizada);
    socket.on('ordenAsignada', handleOrdenActualizada);
    socket.on('estadoActualizado', handleOrdenActualizada);

    return () => {
      socket.off('ordenActualizada', handleOrdenActualizada);
      socket.off('ordenAsignada', handleOrdenActualizada);
      socket.off('estadoActualizado', handleOrdenActualizada);
    };
  }, [socket, idOrden, onUpdate]);

  return { ordenModificada, ultimaActualizacion, resetear };
};
